import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './Toggle.css';

const cx = classnames.bind(styles);

class Toggle extends Component {
  static propTypes = {
    name           : string,
    label          : string,
    onLabel        : string,
    offLabel       : string,
    disabled       : bool,
    greenBg        : bool,
    greyBg         : bool,
    withSideLabel  : bool,
    withStatusLabel: bool,
    darkBg         : bool,
    checked        : bool,
    onChange       : func,
    onFocus        : func,
    onBlur         : func,
  }

  static defaultProps = {
    onLabel : 'On',
    offLabel: 'Off',
    checked : false,
  }

  state = {
    isOn: this.props.checked,
    hasFocus: false,
  }

  handleToggle = () => {
    const { disabled, onChange } = this.props;
    const { isOn } = this.state;
    if (disabled) { return; }

    if (onChange) { onChange({ isOn: !isOn }); }

    this.setState({ isOn: !isOn });
  }

  handleFocus = e => {
    const { onFocus } = this.props;

    if (onFocus) { onFocus(e); }

    this.setState({ hasFocus: true });
  }

  handleBlur = e => {
    const { onBlur } = this.props;

    if (onBlur) { onBlur(e); }

    this.setState({ hasFocus: false });
  }

  render () {
    const { isOn, hasFocus } = this.state;

    const {
      greenBg,
      greyBg,
      darkBg,
      disabled,
      label,
      name,
      offLabel,
      onLabel,
      withSideLabel,
      withStatusLabel,
    } = this.props;

    const toggleClasses = cx('toggle', {
      greenBg,
      greyBg,
      darkBg,
      disabled,
      off: !isOn,
      on: isOn ,
      withSideLabel,
      withStatusLabel,
    });

    const offLabelClasses = classnames('status-label p', {active: !isOn});
    const onLabelClasses = classnames('status-label p', {active: isOn});
    const toggleThumbClasses = classnames('toggle-thumb', {'has-focus': hasFocus});

    return (
      <div className={toggleClasses}>
        { label ? <label htmlFor={name}>{ label }</label> : '' }

        <div className="toggle-track-wrapper">
          <span className={offLabelClasses}>{ withStatusLabel ? offLabel : '' }</span>

          <div className="toggle-track" onClick={this.handleToggle}>
            <div className={toggleThumbClasses}></div>
          </div>
          <span className={onLabelClasses}>{ withStatusLabel ? onLabel : '' }</span>
        </div>

        <input
          type="checkbox"
          name={name}
          checked={ isOn ? true : false }
          onChange={this.handleToggle}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          aria-label={label}
        />
      </div>
    );
  }
}

Toggle.displayName = 'Toggle';

export default Toggle;



// WEBPACK FOOTER //
// ./src/uis/elements/Toggle/Toggle.js